import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormsConstants } from "src/app/constants/formsConstants";
import { ModalFormComponent } from "../modal-form/modal-form.component";
import { ListValueService } from "src/app/core/services/list-value.service";
import { StatesPetitionsService } from "src/app/core/services/states-petitions.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { TranslateService } from "@ngx-translate/core";
import { DtoCA, StateAvailable } from "../models/states";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { AppConstants } from "src/app/constants/app.constants";

@Component({
  selector: "app-states",
  templateUrl: "./states.component.html",
  styleUrls: ["./states.component.sass"],
})
export class StatesComponent implements OnInit {
  @Input() actualState: string;
  @Input() idPetition: string;
  @Input() release: number;
  @Input() locatorClassModal: string;
  @Input() changeToStatePF: boolean;
  @Input() formUnsaved: boolean = false;
  @Input() isAnalistaTramitante: boolean = false;
  @Input() analistaByPetition: string = "";
  @ViewChild("modal") modal: ModalFormComponent;
  @ViewChild("confirmSwal")
  public readonly confirmSwal!: SwalComponent;

  @ViewChild("formUpdatedWithoutSaveSwal")
  public readonly formUpdatedWithoutSaveSwal!: SwalComponent;

  @Output() reloadPetition = new EventEmitter<string>();

  titleModal: string = "";
  roles = AppConstants.roles;

  valueAux;

  statesAvailableForPF: StateAvailable[] = [
    { descripcion: "Pendiente de firma", estado: "PF" },
    { descripcion: "Corrección Analista", estado: "CA" },
    { descripcion: "Certificado revisado", estado: "CR" },
    { descripcion: "Rechazado", estado: "RE" },
  ];

  statesAvailableAnalistaTramitanteForPF: StateAvailable[] = [
    { descripcion: "Pendiente de análisis", estado: "PA" },
    { descripcion: "En análisis", estado: "AN" },
    { descripcion: "Rechazado", estado: "RE" },
  ];

  statesAvailableAnalistaForPF: StateAvailable[] = [
    { descripcion: "Pendiente de corrección", estado: "PC" },
    { descripcion: "Pendiente de firma", estado: "PF" },
  ];

  statesAvailable: StateAvailable[];

  constructor(
    private listValueService: ListValueService,
    private translateService: TranslateService,
    private toastrAlertService: ToastrAlertService,
    private statesPetitionsService: StatesPetitionsService,
    private sweetAlertService: SweetAlertService
  ) {}

  ngOnInit(): void {
    this.getStatesTransitables();
  }

  onClick(state: StateAvailable) {
    if (this.formUnsaved) {
      this.formUpdatedWithoutSaveSwal.fire();
    } else {
      switch (state.estado) {
        case "RE":
          this.getMotivosRechazo();
          break;
        case "CA":
          this.getListAnalysts();
          break;
        case "PC":
          let form = FormsConstants.changeStateToPC;
          this.modal.open(form, "PC");
          break;
        case "AN":
          this.confirmSwal.fire().then((result) => {
            if (result.isConfirmed) {
              this.changeStateToAN();
            }
          });
          break;
        case "PA":
          if (
            this.actualState == "EF" ||
            this.actualState == "FI" ||
            this.actualState == "RE" ||
            this.actualState == "FG"
          ) {
            let form = FormsConstants.changeStateToPA;
            this.modal.open(form, "PA");
          } else {
            this.confirmSwal.fire().then((result) => {
              if (result.isConfirmed) {
                this.changeStateToPA();
              }
            });
          }
          break;
        case "PF":
          if (state.descripcion == "Pendiente de firma") {
            this.reloadPetition.emit("PF");
          }
          if (state.descripcion == "Pendiente Fichero") {
            this.reloadPetition.emit("PF-Placa");
          }
          break;
        case "CR":
          this.confirmSwal.fire().then((result) => {
            if (result.isConfirmed) {
              this.changeStateToCR();
            }
          });
          break;
        case "FI":
          this.confirmSwal.fire().then((result) => {
            if (result.isConfirmed) {
              this.changeStatetoFI();
            }
          });
          break;
        default:
          break;
      }
    }
  }

  sendForm(value: any) {
    switch (value.type) {
      case "CA":
        this.changeStatetoCA(value);
        break;
      case "RE":
        this.changeStatetoRE(value);
        break;
      case "PC":
        this.changeStatetoPC(value);
        break;
      case "PA":
        this.changeStateToPA(value.form[0].value);
        break;
      default:
        break;
    }
  }

  getStatesTransitables() {
    this.statesPetitionsService
      .getStatesTransitables(this.idPetition)
      .subscribe(
        (data) => {
          this.statesAvailable = data ? data[0] : [];
        },
        (err) => {
          this.sweetAlertService.sweetAlertClose();
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  getMotivosRechazo() {
    this.sweetAlertService.sweetAlertLoading();
    this.listValueService.listMotivosRechazo().subscribe(
      (data) => {
        this.sweetAlertService.sweetAlertClose();
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.analystNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        } else {
          let form = FormsConstants.changeStateToRE;
          form[0].list = data;
          this.modal.open(form, "RE");
        }
      },
      (err) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getListAnalysts() {
    this.sweetAlertService.sweetAlertLoading();
    this.listValueService.listaAnalistasActivos().subscribe(
      (data) => {
        this.sweetAlertService.sweetAlertClose();
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.analystNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        } else {
          let form = FormsConstants.changeStateToCA;
          form[0].value = this.analistaByPetition;
          form[0].list = data;
          this.modal.open(form, "CA");
        }
      },
      (err) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  changeStateToAN() {
    this.sweetAlertService.sweetAlertLoading();
    this.statesPetitionsService
      .changeToAN(this.idPetition, this.actualState)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.sweetAlertService.sweetAlertClose();
          this.reloadPetition.emit("AN");
          this.getStatesTransitables();
        },
        (err) => {
          this.sweetAlertService.sweetAlertClose();
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  changeStateToCR() {
    this.sweetAlertService.sweetAlertLoading();
    this.statesPetitionsService.changeToCR(this.idPetition).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data.mensaje);
        this.sweetAlertService.sweetAlertClose();
        this.reloadPetition.emit("CR");
        this.getStatesTransitables();
      },
      (err) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  changeStateToPA(comentario?: string) {
    this.sweetAlertService.sweetAlertLoading();
    this.statesPetitionsService
      .changeToPA(this.idPetition, comentario)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.sweetAlertService.sweetAlertClose();
          this.reloadPetition.emit("PA");
          this.getStatesTransitables();
        },
        (err) => {
          this.sweetAlertService.sweetAlertClose();
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  changeStatetoCA(value: any) {
    this.sweetAlertService.sweetAlertLoading();
    let dto: DtoCA = {
      peId: this.idPetition,
      peRelease: this.release.toString(),
      analista: value.form[0].value,
      comentario: value.form[1].value,
    };
    this.statesPetitionsService.changeToCA(dto).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data.mensaje);
        this.sweetAlertService.sweetAlertClose();
        this.reloadPetition.emit("CA");
        this.getStatesTransitables();
      },
      (err) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }
  changeStatetoRE(value: any) {
    this.sweetAlertService.sweetAlertLoading();
    this.statesPetitionsService
      .changeToRE(this.idPetition, value.form[1].value, value.form[0].value)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.sweetAlertService.sweetAlertClose();
          this.reloadPetition.emit("RE");
          this.getStatesTransitables();
        },
        (err) => {
          this.sweetAlertService.sweetAlertClose();
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }
  changeStatetoPC(value: any) {
    this.sweetAlertService.sweetAlertLoading();
    this.statesPetitionsService
      .changeToPC(this.idPetition, value.form[0].value, this.actualState)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.sweetAlertService.sweetAlertClose();
          this.reloadPetition.emit("PC");
          this.getStatesTransitables();
        },
        (err) => {
          this.sweetAlertService.sweetAlertClose();
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }
  changeStatetoFI() {
    this.sweetAlertService.sweetAlertLoading();
    this.statesPetitionsService.chanteToFICOC([this.idPetition]).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data.mensaje);
        this.sweetAlertService.sweetAlertClose();
        this.reloadPetition.emit("FI");
        this.getStatesTransitables();
      },
      (err) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }
  changeStatetoPFPlaca(data: any) {
    this.sweetAlertService.sweetAlertLoading();
    this.statesPetitionsService
      .changeToPFPlaca(this.idPetition, data)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.sweetAlertService.sweetAlertClose();
          this.reloadPetition.emit("PF");
          this.getStatesTransitables();
        },
        (err) => {
          this.sweetAlertService.sweetAlertClose();
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }
}
